import React from 'react'
import SignInPageStore from 'store/SignInPageStore'

export const SignInPageContext = React.createContext<SignInPageStore | null>(
  null,
)
